/*
 * @Descripttion:
 * @Author: 老板说这个需求很简单
 * @Date: 2025-05-28 09:27:54
 * @LastEditTime: 2025-06-17 13:52:48
 * @LastEditors: sudo_rm_rf
 */
// 台面组件
const GunTips = defineAsyncComponent(() => import('/@/components/panel/gunTips/index.vue'));
const Pcr = defineAsyncComponent(() => import('/@/components/panel/pcr/index.vue'));
const GunFrame = defineAsyncComponent(() => import('/@/components/panel/gunFrame/index.vue'));
const TemperatureControl = defineAsyncComponent(() => import('/@/components/panel/temperatureControl/index.vue'));
const KitTemp96 = defineAsyncComponent(() => import('/@/components/panel/kitTemp96/index.vue'));
const KitTemp48 = defineAsyncComponent(() => import('/@/components/panel/kitTemp48/index.vue'));
const Qubit = defineAsyncComponent(() => import('/@/components/panel/qubit/index.vue'));
const Quantitative = defineAsyncComponent(() => import('/@/components/panel/quantitative/index.vue'));
const FourTemp = defineAsyncComponent(() => import('/@/components/panel/FourTemp/index.vue'));
const NormalTemp96 = defineAsyncComponent(() => import('/@/components/panel/NormalTemp96/index.vue'));
const MagneticAttraction = defineAsyncComponent(() => import('/@/components/panel/MagneticAttraction/index.vue'));
const CleanPcr = defineAsyncComponent(() => import('/@/components/panel/CleanPcr/index.vue'));
const AbandonedPcr = defineAsyncComponent(() => import('/@/components/panel/AbandonedPcr/index.vue'));
const QuantitativeCache = defineAsyncComponent(() => import('/@/components/panel/QuantitativeCache/index.vue'));
const Oscillation = defineAsyncComponent(() => import('/@/components/panel/Oscillation/index.vue'));
const ConstantOscillation = defineAsyncComponent(() => import('/@/components/panel/ConstantOscillation/index.vue'));
const Recycling1 = defineAsyncComponent(() => import('/@/components/panel/Recycling1/index.vue'));
const Recycling2 = defineAsyncComponent(() => import('/@/components/panel/Recycling2/index.vue'));

// 流程库组件
const TipHeader = defineAsyncComponent(() => import('/@/components/flow/TipHeader.vue'));
const Xitu = defineAsyncComponent(() => import('/@/components/flow/Xitu.vue'));
const DelTip = defineAsyncComponent(() => import('/@/components/flow/DelTip.vue'));
const PcrSeting = defineAsyncComponent(() => import('/@/components/flow/PcrSeting.vue'));
const TempControl = defineAsyncComponent(() => import('/@/components/flow/TempControl.vue'));
const TempConcussion = defineAsyncComponent(() => import('/@/components/flow/TempConcussion.vue'));
const Concussion = defineAsyncComponent(() => import('/@/components/flow/Concussion.vue'));
const Cixi = defineAsyncComponent(() => import('/@/components/flow/Cixi.vue'));
const Handling = defineAsyncComponent(() => import('/@/components/flow/Handling.vue'));
const Pooling = defineAsyncComponent(() => import('/@/components/flow/Pooling.vue'));
const Purification = defineAsyncComponent(() => import('/@/components/flow/Purification/index.vue'));
const FlowPurification = defineAsyncComponent(() => import('/@/components/flow/Quantitative.vue'));
const Homogenization = defineAsyncComponent(() => import('/@/components/flow/Homogenization.vue'));
const MIXSetting = defineAsyncComponent(() => import('/@/components/flow/MIXSetting.vue'));
const Incubation = defineAsyncComponent(() => import('/@/components/flow/Incubation.vue'));
const SheetSieve = defineAsyncComponent(() => import('/@/components/flow/SheetSieve.vue'));
const Dispensing = defineAsyncComponent(() => import('/@/components/flow/Dispensing.vue'));
const Pipetting = defineAsyncComponent(() => import('/@/components/flow/Pipetting.vue'));
const Waiting = defineAsyncComponent(() => import('/@/components/flow/Waiting.vue'));
export default function registerCom(app: any) {
  app
    .component('GunTips', GunTips)
    .component('Pcr', Pcr)
    .component('GunFrame', GunFrame)
    .component('KitTemp96', KitTemp96)
    .component('KitTemp48', KitTemp48)
    .component('Qubit', Qubit)
    .component('Quantitative', Quantitative)
    .component('FourTemp', FourTemp)
    .component('NormalTemp96', NormalTemp96)
    .component('MagneticAttraction', MagneticAttraction)
    .component('CleanPcr', CleanPcr)
    .component('AbandonedPcr', AbandonedPcr)
    .component('QuantitativeCache', QuantitativeCache)
    .component('Oscillation', Oscillation)
    .component('ConstantOscillation', ConstantOscillation)
    .component('Recycling1', Recycling1)
    .component('Recycling2', Recycling2)
    .component('TipHeader', TipHeader)
    .component('TemperatureControl', TemperatureControl)
    .component('Xitu', Xitu)
    .component('DelTip', DelTip)
    .component('TempControl', TempControl)
    .component('TempConcussion', TempConcussion)
    .component('Concussion', Concussion)
    .component('Cixi', Cixi)
    .component('Handling', Handling)
    .component('Pooling', Pooling)
    .component('Purification', Purification)
    .component('FlowPurification', FlowPurification)
    .component('Homogenization', Homogenization)
    .component('MIXSetting', MIXSetting)
    .component('Incubation', Incubation)
    .component('SheetSieve', SheetSieve)
    .component('Dispensing', Dispensing)
    .component('Pipetting', Pipetting)
    .component('Waiting', Waiting)
    .component('PcrSeting', PcrSeting);
}
